import { t } from 'i18next';

import { EXPORT_ROW_LIMIT } from '~constants/consts';
import { alert, AlertTypes } from '~types/AlertTypes';

export function exportRowLimitAlert() {
  return alert(
    t('approvals.export.row_limit_exceeded', {
      limit: EXPORT_ROW_LIMIT.toLocaleString(),
    }),
    AlertTypes.error,
  );
}
